exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-privacy-js": () => import("./../../../src/pages/privacy.js" /* webpackChunkName: "component---src-pages-privacy-js" */),
  "component---src-templates-dsg-js": () => import("./../../../src/templates/dsg.js" /* webpackChunkName: "component---src-templates-dsg-js" */),
  "component---src-templates-of-redirect-js": () => import("./../../../src/templates/of-redirect.js" /* webpackChunkName: "component---src-templates-of-redirect-js" */)
}

